import { useNavigate } from "react-router"
import { useEffect } from "react"
import { COMPANY_REPORTS_ROUTE } from "../../../constants/routes"

type Props = Readonly<{}>

export function CompanyHome({}: Props) {
    const navigate = useNavigate()

    useEffect(() => navigate(COMPANY_REPORTS_ROUTE))

    return null
}
